import { t, defineMessage } from '@lingui/macro';
import { InstrumentFamily } from 'types/enums';
import { Instruments } from 'types/enums/instruments';

// Instruments Family
export const InstrumentFamilyTitles: { [k in InstrumentFamily]: string } = {
    [InstrumentFamily.Bass]: t({ id: 'bass' }),
    [InstrumentFamily.BrassWoodwind]: t({ id: 'brass_woodwind' }),
    [InstrumentFamily.Drums]: t({ id: 'drums' }),
    [InstrumentFamily.Guitars]: t({ id: 'guitars' }),
    [InstrumentFamily.Keys]: t({ id: 'keys' }),
    [InstrumentFamily.MultiInstrument]: t({ id: 'multi_instrument' }),
    [InstrumentFamily.Percussion]: t({ id: 'percussion' }),
    [InstrumentFamily.PitchedPercussion]: t({ id: 'pitched_percussion' }),
    [InstrumentFamily.FX]: t({ id: 'fx' }),
    [InstrumentFamily.Strings]: t({ id: 'strings' }),
    [InstrumentFamily.Synth]: t({ id: 'synth' }),
    [InstrumentFamily.Vocals]: t({ id: 'vocals' }),
};

export const InstrumentTitles: { [k in Instruments]: string } = {
    [Instruments.AcousticGuitar]: t({ id: 'acoustic_guitar' }),
    [Instruments.Autoharp]: t({ id: 'autoharp' }),
    [Instruments.BackingTrack]: t({ id: 'backing_track' }),
    [Instruments.Banjo]: t({ id: 'banjo' }),
    [Instruments.BassGuitar]: t({ id: 'bass_guitar' }),
    [Instruments.Bassoon]: t({ id: 'bassoon' }),
    [Instruments.Beatbox]: t({ id: 'beatbox' }),
    [Instruments.Beats]: t({ id: 'beats' }),
    [Instruments.Bell]: t({ id: 'bell' }),
    [Instruments.Bongo]: t({ id: 'bongo' }),
    [Instruments.Cabasa]: t({ id: 'cabasa' }),
    [Instruments.Celeste]: t({ id: 'celeste' }),
    [Instruments.Cello]: t({ id: 'cello' }),
    [Instruments.Chant]: t({ id: 'chant' }),
    [Instruments.Child]: t({ id: 'child' }),
    [Instruments.Chime]: t({ id: 'chime' }),
    [Instruments.Choir]: t({ id: 'choir' }),
    [Instruments.Clap]: t({ id: 'clap' }),
    [Instruments.Clarinet]: t({ id: 'clarinet' }),
    [Instruments.ClassicalGuitar]: t({ id: 'classical_guitar' }),
    [Instruments.Claves]: t({ id: 'claves' }),
    [Instruments.Conga]: t({ id: 'conga' }),
    [Instruments.Contrabassoon]: t({ id: 'contrabassoon' }),
    [Instruments.Cowbell]: t({ id: 'cowbell' }),
    [Instruments.Crash]: t({ id: 'crash' }),
    [Instruments.Crotales]: t({ id: 'crotales' }),
    [Instruments.Cymbals]: t({ id: 'cymbals' }),
    [Instruments.Digirido]: t({ id: 'digirido' }),
    [Instruments.Djembe]: t({ id: 'djembe' }),
    [Instruments.DoubleBass]: t({ id: 'double_bass' }),
    [Instruments.Downer]: t({ id: 'downer' }),
    [Instruments.Drumkit]: t({ id: 'drumkit' }),
    [Instruments.Duduck]: t({ id: 'duduck' }),
    [Instruments.ElectricGuitar]: t({ id: 'electric_guitar' }),
    [Instruments.ElectricPiano]: t({ id: 'electric_piano' }),
    [Instruments.Erhu]: t({ id: 'erhu' }),
    [Instruments.Female]: t({ id: 'female' }),
    [Instruments.Flute]: t({ id: 'flute' }),
    [Instruments.Foley]: t({ id: 'foley' }),
    [Instruments.FullDrum]: t({ id: 'full_drum' }),
    [Instruments.Glockenspiel]: t({ id: 'glockenspiel' }),
    [Instruments.Gong]: t({ id: 'gong' }),
    [Instruments.Harmonica]: t({ id: 'harmonica' }),
    [Instruments.Harp]: t({ id: 'harp' }),
    [Instruments.Harpsichord]: t({ id: 'harpsichord' }),
    [Instruments.HiHat]: t({ id: 'hi_hat' }),
    [Instruments.Hit]: t({ id: 'hit' }),
    [Instruments.Horn]: t({ id: 'horn' }),
    [Instruments.Impact]: t({ id: 'impact' }),
    [Instruments.Kalimba]: t({ id: 'kalimba' }),
    [Instruments.Kick]: t({ id: 'kick' }),
    [Instruments.Koto]: t({ id: 'koto' }),
    [Instruments.Layer]: t({ id: 'layer' }),
    [Instruments.Male]: t({ id: 'male' }),
    [Instruments.Mandolin]: t({ id: 'mandolin' }),
    [Instruments.Marimba]: t({ id: 'marimba' }),
    [Instruments.Noise]: t({ id: 'noise' }),
    [Instruments.Oboe]: t({ id: 'oboe' }),
    [Instruments.Orchestra]: t({ id: 'orchestra' }),
    [Instruments.Orchestral]: t({ id: 'orchestral' }),
    [Instruments.Organ]: t({ id: 'organ' }),
    [Instruments.Oud]: t({ id: 'oud' }),
    [Instruments.Piano]: t({ id: 'piano' }),
    [Instruments.Quartet]: t({ id: 'quartet' }),
    [Instruments.Reverse]: t({ id: 'reverse' }),
    [Instruments.Rhodes]: t({ id: 'rhodes' }),
    [Instruments.Ride]: t({ id: 'ride' }),
    [Instruments.Rimshot]: t({ id: 'rimshot' }),
    [Instruments.Riser]: t({ id: 'riser' }),
    [Instruments.Saxophone]: t({ id: 'saxophone' }),
    [Instruments.Scream]: t({ id: 'scream' }),
    [Instruments.Shaker]: t({ id: 'shaker' }),
    [Instruments.Shout]: t({ id: 'shout' }),
    [Instruments.Singing]: t({ id: 'singing' }),
    [Instruments.Sitar]: t({ id: 'sitar' }),
    [Instruments.Snap]: t({ id: 'snap' }),
    [Instruments.Snare]: t({ id: 'snare' }),
    [Instruments.SoundDesign]: t({ id: 'sound_design' }),
    [Instruments.SoundEffect]: t({ id: 'sound_effect' }),
    [Instruments.Soundscape]: t({ id: 'soundscape' }),
    [Instruments.Splash]: t({ id: 'splash' }),
    [Instruments.Spoken]: t({ id: 'spoken' }),
    [Instruments.SteelDrum]: t({ id: 'steel_drum' }),
    [Instruments.SteelGuitar]: t({ id: 'steel_guitar' }),
    [Instruments.SteelSlideGuitar]: t({ id: 'steel_slide_guitar' }),
    [Instruments.Sub]: t({ id: 'sub' }),
    [Instruments.Sweep]: t({ id: 'sweep' }),
    [Instruments.SynthBass]: t({ id: 'synth_bass' }),
    [Instruments.SynthLead]: t({ id: 'synth_lead' }),
    [Instruments.SynthPad]: t({ id: 'synth_pad' }),
    [Instruments.SynthPlucked]: t({ id: 'synth_plucked' }),
    [Instruments.SynthPolyphonic]: t({ id: 'synth_polyphonic' }),
    [Instruments.SynthStab]: t({ id: 'synth_stab' }),
    [Instruments.SynthTexture]: t({ id: 'synth_texture' }),
    [Instruments.Tabla]: t({ id: 'tabla' }),
    [Instruments.Tambourine]: t({ id: 'tambourine' }),
    [Instruments.Timbale]: t({ id: 'timbale' }),
    [Instruments.Tom]: t({ id: 'tom' }),
    [Instruments.Triangle]: t({ id: 'triangle' }),
    [Instruments.Trombone]: t({ id: 'trombone' }),
    [Instruments.Trumpet]: t({ id: 'trumpet' }),
    [Instruments.Tuba]: t({ id: 'tuba' }),
    [Instruments.TubularBells]: t({ id: 'tubular_bells' }),
    [Instruments.Ukulele]: t({ id: 'ukulele' }),
    [Instruments.UprightBass]: t({ id: 'upright_bass' }),
    [Instruments.Vibraphone]: t({ id: 'vibraphone' }),
    [Instruments.Viola]: t({ id: 'viola' }),
    [Instruments.Violin]: t({ id: 'violin' }),
    [Instruments.Vocoder]: t({ id: 'vocoder' }),
    [Instruments.Woodblock]: t({ id: 'woodblock' }),
    [Instruments.Wooden]: t({ id: 'wooden' }),
    [Instruments.Xylophone]: t({ id: 'xylophone' }),
};

// Instruments Family
defineMessage({ id: 'bass', message: 'Bass', comment: 'Instrument family' });
defineMessage({
    id: 'brass_woodwind',
    message: 'Brass & Woodwind',
    comment: 'Instrument family',
});
defineMessage({ id: 'drums', message: 'Drums', comment: 'Instrument family' });
defineMessage({
    id: 'guitars',
    message: 'Guitars',
    comment: 'Instrument family',
});
defineMessage({ id: 'keys', message: 'Keys', comment: 'Instrument family' });
defineMessage({
    id: 'multi_instrument',
    message: 'Multi Instrument',
    comment: 'Instrument family',
});
defineMessage({
    id: 'percussion',
    message: 'Percussion',
    comment: 'Instrument family',
});
defineMessage({
    id: 'pitched_percussion',
    message: 'Pitched Percussion',
    comment: 'Instrument family',
});
defineMessage({ id: 'fx', message: 'FX', comment: 'Instrument family' });
defineMessage({
    id: 'strings',
    message: 'Strings',
    comment: 'Instrument family',
});
defineMessage({ id: 'synth', message: 'Synth', comment: 'Instrument family' });
defineMessage({
    id: 'vocals',
    message: 'Vocals',
    comment: 'Instrument family',
});

// Instruments
defineMessage({
    id: 'acoustic_guitar',
    message: 'Acoustic Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'autoharp',
    message: 'Autoharp',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'backing_track',
    message: 'Backing Track',
    comment: 'Musical instrument',
});
defineMessage({ id: 'banjo', message: 'Banjo', comment: 'Musical instrument' });
defineMessage({
    id: 'bass_guitar',
    message: 'Bass Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'bassoon',
    message: 'Bassoon',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'beatbox',
    message: 'Beatbox',
    comment: 'Voice samples category',
});
defineMessage({ id: 'beats', message: 'Beats', comment: 'Musical instrument' });
defineMessage({ id: 'bell', message: 'Bell', comment: 'Musical instrument' });
defineMessage({ id: 'bongo', message: 'Bongo', comment: 'Musical instrument' });
defineMessage({
    id: 'cabasa',
    message: 'Cabasa',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'celeste',
    message: 'Celeste',
    comment: 'Musical instrument',
});
defineMessage({ id: 'cello', message: 'Cello', comment: 'Musical instrument' });
defineMessage({
    id: 'chant',
    message: 'Chant',
    comment: 'Voice samples category',
});
defineMessage({
    id: 'child',
    message: 'Child',
    comment: 'Voice samples category',
});
defineMessage({ id: 'chime', message: 'Chime', comment: 'Musical instrument' });
defineMessage({ id: 'china', message: 'China', comment: 'Musical instrument' });
defineMessage({
    id: 'choir',
    message: 'Choir',
    comment: 'Voice samples category',
});
defineMessage({ id: 'clap', message: 'Clap', comment: 'Musical instrument' });
defineMessage({
    id: 'clarinet',
    message: 'Clarinet',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'classical_guitar',
    message: 'Classical Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'claves',
    message: 'Claves',
    comment: 'Musical instrument',
});
defineMessage({ id: 'conga', message: 'Conga', comment: 'Musical instrument' });
defineMessage({
    id: 'contrabassoon',
    message: 'Contrabassoon',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'cowbell',
    message: 'Cowbell',
    comment: 'Musical instrument',
});
defineMessage({ id: 'crash', message: 'Crash', comment: 'Musical instrument' });
defineMessage({
    id: 'crotales',
    message: 'Crotales',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'cymbals',
    message: 'Cymbals',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'digirido',
    message: 'Didgeridoo',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'djembe',
    message: 'Djembe',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'double_bass',
    message: 'Double Bass',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'downer',
    message: 'Downer',
    comment: 'FX samples category',
});
defineMessage({ id: 'drumkit', message: 'Kit', comment: 'Musical instrument' });
defineMessage({
    id: 'duduck',
    message: 'Duduck',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'electric_guitar',
    message: 'Electric Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'electric_piano',
    message: 'Electric Piano',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'english_horn',
    message: 'English Horn',
    comment: 'Musical instrument',
});
defineMessage({ id: 'erhu', message: 'Erhu', comment: 'Musical instrument' });
defineMessage({
    id: 'female',
    message: 'Female',
    comment: 'Voice samples category',
});
defineMessage({ id: 'flute', message: 'Flute', comment: 'Musical instrument' });
defineMessage({ id: 'foley', message: 'Foley', comment: 'Musical instrument' });
defineMessage({
    id: 'french_horn',
    message: 'French Horn',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'full_drum',
    message: 'Full Drum',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'glockenspiel',
    message: 'Glockenspiel',
    comment: 'Musical instrument',
});
defineMessage({ id: 'gong', message: 'Gong', comment: 'Musical instrument' });
defineMessage({
    id: 'harmonica',
    message: 'Harmonica',
    comment: 'Musical instrument',
});
defineMessage({ id: 'harp', message: 'Harp', comment: 'Musical instrument' });
defineMessage({
    id: 'harpsichord',
    message: 'Harpsichord',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'hi_hat',
    message: 'Hi-Hat',
    comment: 'Musical instrument',
});
defineMessage({ id: 'hit', message: 'Hit', comment: 'Musical instrument' });
defineMessage({ id: 'horn', message: 'Horn', comment: 'Musical instrument' });
defineMessage({
    id: 'impact',
    message: 'Impact',
    comment: 'FX samples category',
});
defineMessage({
    id: 'kalimba',
    message: 'Kalimba',
    comment: 'Musical instrument',
});
defineMessage({ id: 'kick', message: 'Kick', comment: 'Musical instrument' });
defineMessage({ id: 'kit', message: 'Kit', comment: 'Musical instrument' });
defineMessage({ id: 'koto', message: 'Koto', comment: 'Musical instrument' });
defineMessage({ id: 'layer', message: 'Layer', comment: 'Musical instrument' });
defineMessage({
    id: 'layered',
    message: 'Layered',
    comment: 'Musical instrument',
});
defineMessage({ id: 'lead', message: 'Lead', comment: 'Musical instrument' });
defineMessage({
    id: 'male',
    message: 'Male',
    comment: 'Voice samples category',
});
defineMessage({
    id: 'mandolin',
    message: 'Mandolin',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'marimba',
    message: 'Marimba',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'metallic',
    message: 'Metallic',
    comment: 'Musical instrument',
});
defineMessage({ id: 'noise', message: 'Noise', comment: 'Musical instrument' });
defineMessage({ id: 'oboe', message: 'Oboe', comment: 'Musical instrument' });
defineMessage({
    id: 'orchestra',
    message: 'Orchestra',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'orchestral',
    message: 'Orchestral',
    comment: 'Musical instrument',
});
defineMessage({ id: 'organ', message: 'Organ', comment: 'Musical instrument' });
defineMessage({ id: 'oud', message: 'Oud', comment: 'Musical instrument' });
defineMessage({ id: 'pad', message: 'Pad', comment: 'Musical instrument' });
defineMessage({ id: 'piano', message: 'Piano', comment: 'Musical instrument' });
defineMessage({
    id: 'plucked',
    message: 'Plucked',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'polyphonic',
    message: 'Polyphonic',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'quartet',
    message: 'Quartet',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'recorder',
    message: 'Recorder',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'reverse',
    message: 'Reverse',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'rhodes',
    message: 'Rhodes',
    comment: 'Musical instrument',
});
defineMessage({ id: 'ride', message: 'Ride', comment: 'Musical instrument' });
defineMessage({
    id: 'rimshot',
    message: 'Rimshot',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'riser',
    message: 'Riser',
    comment: 'FX samples category',
});
defineMessage({
    id: 'saxophone',
    message: 'Saxophone',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'scream',
    message: 'Scream',
    comment: 'Voice samples category',
});
defineMessage({
    id: 'shaker',
    message: 'Shaker',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'shout',
    message: 'Shout',
    comment: 'Voice samples category',
});
defineMessage({
    id: 'singing',
    message: 'Singing',
    comment: 'Voice samples category',
});
defineMessage({ id: 'sitar', message: 'Sitar', comment: 'Musical instrument' });
defineMessage({ id: 'snap', message: 'Snap', comment: 'FX samples category' });
defineMessage({ id: 'snare', message: 'Snare', comment: 'Musical instrument' });
defineMessage({
    id: 'sound_design',
    message: 'Sound Design',
    comment: 'FX samples category',
});
defineMessage({
    id: 'sound_effect',
    message: 'Sound Effect',
    comment: 'FX samples category',
});
defineMessage({
    id: 'soundscape',
    message: 'Soundscape',
    comment: 'FX samples category',
});
defineMessage({
    id: 'splash',
    message: 'Splash',
    comment: 'FX samples category',
});
defineMessage({
    id: 'spoken',
    message: 'Spoken',
    comment: 'Voice samples category',
});
defineMessage({ id: 'stab', message: 'Stab', comment: 'FX samples category' });
defineMessage({
    id: 'steel_drum',
    message: 'Steel Drum',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'steel_guitar',
    message: 'Steel Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'steel_slide_guitar',
    message: 'Steel Slide Guitar',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'sub',
    message: 'Sub',
    comment: 'Short for low frequency bass',
});
defineMessage({
    id: 'sweep',
    message: 'Sweep',
    comment: 'FX samples category',
});
defineMessage({
    id: 'synth_bass',
    message: 'Synth Bass',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_lead',
    message: 'Synth Lead',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_pad',
    message: 'Synth Pad',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_plucked',
    message: 'Synth Plucked',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_polyphonic',
    message: 'Synth Polyphonic',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_stab',
    message: 'Synth Stab',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'synth_texture',
    message: 'Synth Texture',
    comment: 'Musical instrument',
});
defineMessage({ id: 'tabla', message: 'Tabla', comment: 'Musical instrument' });
defineMessage({
    id: 'tambourine',
    message: 'Tambourine',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'texture',
    message: 'Texture',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'timbale',
    message: 'Timbale',
    comment: 'Musical instrument',
});
defineMessage({ id: 'tom', message: 'Tom', comment: 'Musical instrument' });
defineMessage({
    id: 'triangle',
    message: 'Triangle',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'trombone',
    message: 'Trombone',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'trumpet',
    message: 'Trumpet',
    comment: 'Musical instrument',
});
defineMessage({ id: 'tuba', message: 'Tuba', comment: 'Musical instrument' });
defineMessage({
    id: 'tubular_bells',
    message: 'Tubular Bells',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'ukulele',
    message: 'Ukulele',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'upright_bass',
    message: 'Upright Bass',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'vibraphone',
    message: 'Vibraphone',
    comment: 'Musical instrument',
});
defineMessage({ id: 'viola', message: 'Viola', comment: 'Musical instrument' });
defineMessage({
    id: 'violin',
    message: 'Violin',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'vocoder',
    message: 'Vocoder',
    comment: 'Voice samples category',
});
defineMessage({
    id: 'whistle',
    message: 'Whistle',
    comment: 'FX samples category',
});
defineMessage({
    id: 'woodblock',
    message: 'Woodblock',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'wooden',
    message: 'Wooden',
    comment: 'Musical instrument',
});
defineMessage({
    id: 'xylophone',
    message: 'Xylophone',
    comment: 'Musical instrument',
});
